/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type HelpCenterSettingsArticlesViewArticleAppEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line typescript/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const HelpCenterSettingsArticlesViewArticleAppEntryPoint: EntryPoint<
	HelpCenterSettingsArticlesViewArticleAppEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<HelpCenterSettingsArticlesViewArticleAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-setting-support-view-article-app" */ './HelpCenterSettingsArticlesViewArticleComponent.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => {
		return {};
	},
});
